import React from 'react';
import { MathsBadge } from '../shared/MathsBadge';
export function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-gradient-to-br from-purple-50 to-blue-50 py-20 md:py-28 relative overflow-hidden" data-id="element-185">
      {/* Geometric shapes for visual interest */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-purple-200 rounded-bl-full opacity-20" data-id="element-186"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-200 rounded-tr-full opacity-20" data-id="element-187"></div>
      <div className="absolute top-1/4 left-1/4 w-16 h-16 bg-indigo-300 rotate-45 opacity-10 animate-bounce" style={{
      animationDuration: '3s'
    }} data-id="element-188"></div>
      <div className="absolute bottom-1/4 right-1/3 w-12 h-12 bg-purple-300 rounded-full opacity-20 animate-pulse" style={{
      animationDuration: '4s'
    }} data-id="element-189"></div>
      {/* Math badges */}
      <MathsBadge imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/5sYuSQtSRjmzuvk5F5SXRM/Love_maths.png" altText="Love Maths Badge" size="medium" className="absolute top-20 right-20 hidden md:block z-10" data-id="element-190" />
      <MathsBadge imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/hrz8WCxBsxSDCsr4NXoNd9/Cat.png" altText="Math Cat Badge" size="small" className="absolute bottom-24 left-16 hidden md:block z-10" data-id="element-191" />
      <div className="container mx-auto px-4 relative z-10" data-id="element-192">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-193">
          <div data-id="element-194">
            <div className="inline-block bg-gradient-to-r from-purple-600 to-blue-600 text-white text-sm font-medium px-4 py-1.5 rounded-full mb-6 shadow-sm animate-pulse" data-id="element-195">
              📅 Starting: September 2026
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-196">
              Help Close the{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-blue-600" data-id="element-197">
                Maths Attainment Gap
              </span>
            </h1>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed max-w-xl" data-id="element-198">
              A large-scale research study partnering with UK schools to
              evaluate how Eedi supports KS3 students in overcoming
              misconceptions and achieving lasting progress in mathematics.
            </p>

            {/* Impact Highlight Box */}
            <div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white p-6 rounded-lg shadow-lg mb-8 border-2 border-purple-700" data-id="element-199">
              <p className="text-lg font-semibold mb-2" data-id="element-200">
                In our last independent trial, students gained 2–4 extra months
                of maths progress from short weekly Eedi sessions.
              </p>
              <p className="text-white/90" data-id="element-201">
                This new national study is bigger, better, and even more
                ambitious, so we're expecting impact to be even stronger.
              </p>
            </div>

            <div className="flex flex-wrap gap-4" data-id="element-202">
              <button onClick={() => scrollToSection('application-form')} className="px-6 py-3 rounded-lg bg-gradient-to-r from-purple-600 to-blue-600 text-white font-medium hover:opacity-90 transition-all transform hover:scale-105 duration-200 shadow-md" data-id="element-203">
                Apply Now
              </button>
              <button onClick={() => scrollToSection('key-benefits')} className="px-6 py-3 rounded-lg border-2 border-purple-600 text-purple-700 font-medium hover:bg-purple-50 transition-all transform hover:scale-105 duration-200" data-id="element-204">
                Learn More
              </button>
            </div>
            {/* Quick Stats */}
            <div className="grid grid-cols-2 md:grid-cols-2 gap-4 mt-8" data-id="element-205">
              <div className="bg-white/80 backdrop-blur-sm p-3 rounded-lg shadow-sm border border-purple-100" data-id="element-206">
                <div className="text-xl font-bold text-blue-700" data-id="element-207">35</div>
                <div className="text-sm text-gray-600" data-id="element-208">spaces available</div>
              </div>
              <div className="bg-white/80 backdrop-blur-sm p-3 rounded-lg shadow-sm border border-purple-100" data-id="element-209">
                <div className="text-xl font-bold text-indigo-700" data-id="element-210">UK-wide</div>
                <div className="text-sm text-gray-600" data-id="element-211">research study</div>
              </div>
            </div>
          </div>
          <div className="flex justify-center flex-col" data-id="element-212">
            <div className="relative" data-id="element-213">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-200/30 to-blue-200/30 rounded-lg blur-xl transform rotate-6" data-id="element-214"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vhW2ksU3Pn356wVRQFj3g9/Testbed_school_illustration.png" alt="School illustration with teacher and students" className="rounded-lg shadow-xl max-w-full h-auto animate-float relative z-10" data-id="element-215" />
              {/* Feature highlights - repositioned to be more visible */}
              <div className="absolute -bottom-4 -right-4 bg-white rounded-lg shadow-lg p-3 border-l-4 border-purple-500 transform rotate-2 animate-pulse z-20" data-id="element-216">
                <p className="text-sm font-medium text-gray-800" data-id="element-217">
                  Live 1-to-1 tutor support
                </p>
              </div>
              <div className="absolute -top-4 -left-4 bg-white rounded-lg shadow-lg p-3 border-l-4 border-blue-500 transform -rotate-2 animate-pulse z-20" style={{
              animationDelay: '1s'
            }} data-id="element-218">
                <p className="text-sm font-medium text-gray-800" data-id="element-219">
                  Misconception detection
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}